import useResourceList from './useResourceList';
import usePublishedResourceList from './usePublishedResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

import api from '..';

export const useArticlesList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'articles', api: api.articles }, queryVariables, queryConfig);

  return {
    articles: queryResult.resolvedData,
    latestArticles: queryResult.latestData,
    ...queryResult,
  };
};

export const useArticlesPublishedList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = usePublishedResourceList({ name: 'articles', api: api.articles }, queryVariables, queryConfig);

  return {
    articles: queryResult.resolvedData,
    latestArticles: queryResult.latestData,
    ...queryResult,
  };
};

export const useArticlesByIds = (ids, locale = 'en', { passErrors, ...queryConfig } = {}) => {
  const queryResult = useQuery(['articles', { ids, passErrors, locale }], api.articles.getByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  return {
    articles: queryResult.data || [],
    ...queryResult,
  };
};

export const useArticle = (id, locale, queryConfig = {}) => {
  const queryResult = useQuery(['article', { id, locale }], api.articles.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    article: queryResult.data || {},
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'articles' });

export const useDeleteArticle = createMutation(api.articles.remove);

export const useCreateArticle = createMutation(api.articles.create);

export const useUpdateArticle = createMutation(api.articles.update);

export const usePublishArticle = createMutation(api.articles.publish);

export const useUnpublishArticle = createMutation(api.articles.unpublish);

export const useDuplicateArticle = createMutation(api.articles.duplicate);
